<template>
  <div class="credit-cards">
    <h2 class="section-title">熱門信用卡優惠</h2>
    <section id="cards" class="cards">


      <div
            v-for="offerCard in getRecommendTop3Cards()"
            :key="offerCard.id"
            class="card"
          >
          <div class="card-image-div">

            <div class="card-image-container">

            <img :src="getOfferCardImageURL(offerCard.id)" :alt="`${offerCard.name} Image`"  class="card-image"
            @error="onImageError($event)"
            @click="goCardLInk(offerCard.link_url)"
            />
            </div>
            </div>
            <div class="card-content">
              <h3 class="item-text-bold" >{{ offerCard.offer }}</h3>
              <p >{{ offerCard.bank + ' | ' + offerCard.name }}</p>
              <!-- <h3>{{ offerCard.display_order }}</h3> -->
              <!-- <a :href="offerCard.link_url" target="_blank" class="apply-button">Apply</a> -->
              <!-- <button class="add-button" @click="attempAddToRegisteredCard(offerCard)">Add to Registered Cards</button> -->
            </div>
      </div>      

    </section>
      <button class="more-btn" @click="navigateToOfferCards()">看更多信用卡優惠</button>
      <!-- <router-link to="/offer-cards" class="btn-more">
      看更多信用卡優惠
    </router-link>     -->

  </div>
</template>

<script>
import { onImageError, getFullImageURL } from '@/util/util';
import { mapGetters } from 'vuex';

export default {
    name: 'AppCards',
    props: {
      visible: {
        type: Boolean,
        required: true
      },

    },
    computed: {
    ...mapGetters([ 'offer_cards']),
    },    
    methods: {
      onImageError,
      getFullImageURL,
      goCardLInk(link_url) {
        window.open(link_url, '_blank');
      },

      getRecommendTop3Cards() {
        const recommendCards = this.offer_cards.filter(card => card.offer === '推薦卡片');  
        //sort by display_order
        recommendCards.sort((a, b) => a.display_order - b.display_order);
        return recommendCards.slice(0, 3);
      },
      closeModal() {
        this.$emit('close');
      },
      getOfferCardImageURL(offerCardId) {
        const cardImageDict = {};
        this.offer_cards.forEach(card => {
          cardImageDict[card.id] = card.card_image;
        });
  
        const card_image_path = cardImageDict[offerCardId];
        if (!card_image_path) {
          return getFullImageURL("/images/placeholder.png");
        }
  
        return getFullImageURL(card_image_path);
      },
      navigateToOfferCards() {
      this.$router.push('/offer-cards');
      }
    }
  };

</script>

<style scoped>
.credit-cards {
  width: 1416px;
  margin: 0 auto;

  width: var(--home-component-width);

}


.cards {
  /* display: grid; */
  display: flex;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 24px;
  /* align the divs center horizontally */
  justify-content: center;
  margin: 0 auto;
}

.card {
  /* background-color: white; */
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;

  /* width: 23.75%; */
  width: 456px;
}

.card-image-div {
  width: 456px;
  height: 282px;
  margin-bottom: 0;
  background-color: white;
  border-radius: 10px;

  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  border-radius: 20px;

   display: flex;
  justify-content: center;
  align-items: center; 
}

.card-image-container {
  width: 240px;
  height: 152px; /* Maintains the 456x364 aspect ratio */
  overflow: hidden; /* Ensures the image doesn't overflow the container */
  border-radius: 10px;
  background-color: white;
  margin:  auto;
  display: flex;
  justify-content: center;
  align-items: center;

}


.card-image {
  width: 100%;
  height: 100%;

  object-fit: cover;

  /* height: auto; */
  /* margin-top: 23%; */
  /* margin: 23% auto; */
  /* margin-bottom: 15%; */
  
}

.card-content {
  text-align: center;
  line-height: 1.2rem;
  letter-spacing: 0.05em;
  margin-top: 0;
  padding-top: 0;
}
/* 
h3 {
  color: var(--green03);
  margin-top: 20px;
  margin-bottom: 10px;
  letter-spacing: 0.05em;
  font-weight: 700;
} */

p {
  /* color: #666; */
  color: var(--gray15);

  font-size: 16px;
  font-weight: 400;
  margin-top: 8px;

  letter-spacing: 0.05em;
}




@media (max-width: 560px) {



  .credit-cards {
    margin-top: 40px;
    width: 100%;
    /* height: 1186px; */
  }

  .cards {
    /* display: grid; */
    display: flex;
    /* grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)); */
    flex-direction: column;
    gap: 32px;
    width: 343px;
    /* align the divs center horizontally */
    justify-content: center;
    margin: 0 auto;
  }

  .card {
    /* background-color: white; */
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0px;

    width: 100%;
  }

  .card-image-div {
    width: 343px;
    height: 282px;
    margin-bottom: 0;
    background-color: white;
    border-radius: 10px;

    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    border-radius: 20px;
  }

  .card-image {
    width: 240px;
    height: 152px;
    /* margin-top: 23%; */
    margin: 66 auto;
    /* margin-bottom: 15%; */
  }

  .card-content {
    text-align: center;
    line-height: 1.2rem;
    letter-spacing: 0.05em;
    margin-top: 0;
    padding-top: 0;
  }

  h3 {
    display:none;

  }

  p {
    /* color: #666; */
    color: var(--green03);

    font-size: 16px;
    font-weight: 700;
    margin-top: 20px;
    margin-bottom: 0px;

    letter-spacing: 0.05em;
  }




}

@media (max-width: 360px) {}
</style>
